import { ButtonLink, Container, RiAddLine } from 'component-library';
import { useTranslation } from 'react-i18next';

import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { Workstreams } from '@/pages/shared/home/components/Workstreams';
import { paths } from '@/routing';

import { useMenuItems } from '../hooks/useMenuItems';

export const WorkstreamsPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();
  const isStaff = useIsStaffUser();

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: t('navbar.workstreams'),
        children: isStaff && (
          <ButtonLink to={paths.staff.workstreamsAdd} variant='contained' leftAdornment={<RiAddLine />}>
            {t('global.workstream.actions.add')}
          </ButtonLink>
        ),
      }}
    >
      <Container gutterWidth={{ sm: 4 }} className='gap-10 my-8'>
        <Workstreams isEditView hasSearch hasCreate />
      </Container>
    </SignedInPageLayout>
  );
};
